var _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _rect3, _rect4, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 229,
    viewBox: "0 0 226 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.453 6.99482C147.494 1.39562 175.144 7.94285 193.853 23.5486C212.22 38.8701 215.312 64.2765 219.658 87.2448C223.564 107.893 223.424 128.417 217.512 148.598C211.211 170.11 204.587 194.106 184.88 205.974C165.358 217.731 140.502 208.34 117.441 208.864C92.526 209.43 66.0464 221.247 44.5019 209.165C22.3266 196.729 12.2332 170.849 6.72889 146.777C1.49114 123.871 0.869349 97.9355 14.6512 78.6209C27.5187 60.5877 56.1117 63.6161 74.8883 51.2551C93.7597 38.8318 101.204 12.1765 123.453 6.99482Z",
    fill: "#F5F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9631 206.48L81.8955 133.021C82.7362 130.316 85.737 128.141 88.5529 128.175L157.361 127.731L158.076 125.949L160.171 120.948C161.032 118.95 163.362 117.389 165.469 117.443L174.871 117.439L195.107 117.273C197.923 117.307 199.4 119.389 198.444 122.079L193.318 135.478L170.389 205.903C169.937 207.486 168.693 208.843 167.167 209.692C166.018 210.357 164.785 210.776 163.616 210.733L62.1235 211.281C60.9542 211.238 59.6016 210.818 58.5113 210.199C57.8144 209.28 57.5269 207.948 57.9631 206.48Z",
    fill: "#80BBAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.648 150.386L72.6338 166.326L48.9971 83.4414L109.1 67.1911C112.21 66.3359 115.398 68.2019 116.253 71.312L135.691 143.311C136.546 146.343 134.758 149.531 131.648 150.386Z",
    fill: "#80BBAD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.8496,
    y: 95.1494,
    width: 45.061,
    height: 4.80961,
    rx: 2.40481,
    transform: "rotate(-16.6385 66.8496 95.1494)",
    fill: "#C0D4CB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.4189,
    y: 101.704,
    width: 44.4787,
    height: 8.82514,
    rx: 3,
    transform: "rotate(-16.6385 69.4189 101.704)",
    fill: "#C0D4CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8327 165.16L69.9905 167.103C68.9797 167.414 67.969 166.792 67.6579 165.782L46.1205 86.1631C45.8095 85.1523 46.4315 84.1415 47.4423 83.8305L54.2845 81.8867L76.8327 165.16Z",
    fill: "#003F2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8327 165.16L69.9905 167.103C68.9797 167.414 67.969 166.792 67.6579 165.782L46.1205 86.1631C45.8095 85.1523 46.4315 84.1415 47.4423 83.8305L54.2845 81.8867L76.8327 165.16Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.199 79.0078L175.653 95.5482C175.653 95.5482 176.615 134.912 155.715 160.043C131.482 152.029 104.555 143.054 104.555 143.054C104.555 143.054 122.827 123.564 125.199 79.0078Z",
    fill: "#DFE6E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.916,
    y: 95.584,
    width: 34.352,
    height: 2.00224,
    rx: 1.00112,
    transform: "rotate(17.389 131.916 95.584)",
    fill: "#CAD1D3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130.805,
    y: 99.0479,
    width: 19.6159,
    height: 2.00224,
    rx: 1.00112,
    transform: "rotate(17.389 130.805 99.0479)",
    fill: "#CAD1D3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.34 120.811L136.016 121.965L137.17 123.288L143.179 130.155C139.146 132.868 133.634 132.261 130.331 128.491C126.811 124.431 127.18 118.288 131.263 114.727C135.033 111.424 140.595 111.567 144.207 114.802L137.34 120.811Z",
    fill: "#F5F7F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.565 131.833L135.933 121.918L145.849 113.286C150.168 118.903 149.602 126.905 144.565 131.833Z",
    fill: "#003F2D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.565 131.833L135.933 121.918L145.849 113.286C150.168 118.903 149.602 126.905 144.565 131.833Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.226 134.813L81.4434 134.604L141.311 134.229C144.127 134.262 147.12 136.435 147.926 139.131L167.935 205.802C168.421 207.396 168.001 208.749 167.167 209.692C166.018 210.357 164.785 210.776 163.616 210.733L62.1234 211.281C60.954 211.239 59.6014 210.818 58.5111 210.199C57.1064 209.301 55.9956 207.974 55.5089 206.38L35.4998 139.709C34.8094 137.029 36.4101 134.78 39.226 134.813Z",
    fill: "#C0D4CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.6213a2718bc1ebbb2b1c230a4321ff42.svg";
export { ForwardRef as ReactComponent };